$shm_hitalama_skills $mol_book2
	menu_title \Скиллы
	pages <= skill_pages /$mol_view
	List $shm_list_page
		title \Скиллы
		minimal_width 320
		filter? <=> query? \
		sort_order? <=> sort_order? \asc
		add_content /
			<= Add $mol_pop_over
				align \bottom_right
				event *
					^
					mouseenter? <=> add_enter? null
					keydown? <=> add_keydown? null
				Anchor <= Add_anchor $mol_button_minor
					click? <=> add_open? null
					sub /
						<= Add_icon $mol_icon_plus
						\Добавить
				bubble_content <= add_content /$mol_view
			<= Repository_toggle $mol_check_icon
				hint \Репозиторий скиллов
				checked? <=> repository_opened? false
				Icon <= Repository_icon $mol_icon_cog
		body /
			<= Public_notice $mol_text
				text \Все скиллы публично доступны в гипербазе
			<= Names $shm_hitalama_skills_drag
				catalog <= catalog $shm_hitalama_skills_catalog
				locked <= drag_locked false
				reversed <= drag_reversed false
				roots <= roots /
				children* <= children* /
				expanded*? <=> expanded*? true
				Item* <= Item* $shm_hitalama_skills_item
					entry <= entry* $shm_hitalama_skills_entry
					catalog <= catalog
					add_skill? <=> add_skill_in*? null
					add_group? <=> add_group_in*? null
	Add_menu $mol_list
		sub /
			<= Add_group $mol_button_minor
				click? <=> add_group? null
				sub /
					<= Group_icon $mol_icon_folder
					\Группа
			<= Add_skill $mol_button_minor
				click? <=> add_skill? null
				sub /
					<= Skill_icon $mol_icon_plus
					\Скилл
	Create_form $mol_list
		sub /
			<= Name $mol_string
				hint <= new_name_hint \Имя скилла, например hitalama-maps
				value? <=> new_name? \
			<= Parent $mol_select
				dictionary <= folder_options *
				value? <=> new_parent? \
			<= Create_actions $mol_view
				sub /
					<= Create $mol_button_major
						title <= create_title \Создать скилл
						click? <=> create? null
					<= Cancel $mol_button_minor
						title \Отмена
						click? <=> cancel_create? null
	Help $shm_hitalama_guide_toggle
		section \skills
	create_kind? \
	Repository $shm_hitalama_skills_repository
		catalog <= catalog
		opened? <=> repository_opened?
	Viewer $shm_hitalama_skills_editor
		entry <= selected_entry $shm_hitalama_skills_entry
		editing false
		editor_open? <=> editing? false
	Editor $shm_hitalama_skills_editor
		entry <= selected_entry $shm_hitalama_skills_entry
		editing true
		tools /
			<= Delete_skill $shm_confirm_delete
				title \Удалить скилл
				question \Удалить скилл из каталога?
				confirmed? <=> delete_skill? null
			<= Close_editor $mol_button_minor
				hint \Закрыть редактор
				click? <=> close_editor? null
				sub / <= Editor_close_icon $mol_icon_close
